import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GenericErrorPageComponent } from './components/generic-error-page/generic-error-page.component';
import { PendingApprovalComponent } from './components/pending-approval/pending-approval.component';
import { SupplierComponent } from './components/supplier/supplier.component';

import { EmptyPathLanguageIdGuard, LanguageIdGuard } from '@shared/guards';
import { AuthenticationWrapperGuard, PendingApprovalGuard } from './guards';
import { AuthenticationGuard } from '@shared/guards';
import { EnquiryMigratedGuard } from '@shared/guards/enquiry-migrated/enquiry-migrated.guard';
import { SupplierDefaultPageGuard } from '@shared/guards/supplier-default/supplier-default.guard';

export const routes: Routes = [
  {
    path: 'reset-password',
    loadChildren: () => import('./features/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
    data: {
      title: 'Reset Password'
    }
  },
  /* SUPPLIER */
  {
    path: 'su/:listingUuid',
    component: SupplierComponent,
    canActivate: [AuthenticationWrapperGuard],
    children: [
      {
        path: 'pending-approval/:languageId',
        component: PendingApprovalComponent,
        canActivate: [LanguageIdGuard, PendingApprovalGuard]
      },
      {
        path: 'inbox',
        loadChildren: () => import('./modules/inbox/inbox.module').then(m => m.InboxModule)
      },
      {
        path: 'manage',
        children: [
          {
            path: ':languageId',
            canActivate: [LanguageIdGuard],
            children: [
              {
                path: 'templates',
                loadChildren: () => import('./features/templates/templates.module').then(m => m.TemplatesModule)
              },
              {
                path: '',
                redirectTo: 'templates',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: '',
            canActivate: [EmptyPathLanguageIdGuard],
            children: [],
            data: {
              redirectTo: 'templates'
            }
          }
        ]
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'account',
        loadChildren: () => import('./features/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'availability',
        loadChildren: () => import('./features/availability/availability.module').then(m => m.AvailabilityModule),
        data: {
          title: 'Availability'
        }
      },
      {
        path: 'emails',
        loadChildren: () => import('./features/email/email.module').then(m => m.EmailModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./features/customers/customers.module').then(m => m.CustomersModule),
        data: {
          title: 'Customers'
        }
      },
      {
        path: 'staff',
        loadChildren: () => import('./features/staff/staff.module').then(m => m.StaffModule),
        data: {
          title: 'Staff'
        }
      },
      {
        path: 'enquiries',
        loadChildren: () => import('./features/enquiries/enquiries.module').then(m => m.EnquiriesModule)
      },
      {
        path: 'quotes',
        canActivate: [AuthenticationGuard, EnquiryMigratedGuard],
        data: { title: 'Quotes' },
        loadChildren: () =>
          import('./features/enquiries/modules/migrated-quotes/migrated-quotes.module').then(m => m.MigratedQuotesModule)
      },
      {
        path: 'bookings',
        canActivate: [AuthenticationGuard, EnquiryMigratedGuard],
        data: { title: 'Bookings' },
        loadChildren: () =>
          import('./features/enquiries/modules/migrated-bookings/migrated-bookings.module').then(m => m.MigratedBookingsModule)
      },
      {
        path: 'integrations',
        loadChildren: () => import('./features/integrations/integrations.module').then(m => m.IntegrationsModule),
        data: {
          title: 'Pro Settings'
        }
      },
      {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.module').then(m => m.NotificationsModule),
        data: {
          title: 'Request Preferences'
        }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        data: {
          title: 'Dashboard'
        }
      },
      {
        path: 'documents',
        loadChildren: () => import('./features/documents/documents.routes').then(m => m.DOCUMENTS_ROUTES),
        data: {
          title: 'Documents'
        }
      },
      {
        path: '',
        canActivate: [SupplierDefaultPageGuard],
        children: []
      }
    ]
  },
  {
    path: 'error',
    component: GenericErrorPageComponent
  },
  /* CHECKOUT */
  {
    path: 'checkout',
    loadChildren: () => import('./features/checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: '',
    redirectTo: 'su/me',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'su/me',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
      enableTracing: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
